module.exports = __webpack_public_path__ + "img/recollection.476315d0.jpg";